<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-half">
        <div
          class="file my-2"
          :class="disable ? 'is-danger' : 'is-info'"
        >
          <label class="file-label">
            <input
              ref="file"
              class="file-input"
              type="file"
              accept="image/jpg, image/jpeg, image/png"
              :disabled="disable"
              @change="updateProfilePicture()"
            />
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label">Change Profile Picture</span>
            </span>
          </label>
        </div>
        <!-- Profile form -->
        <ValidationObserver
          ref="observer"
          v-slot="{ pristine, invalid, passes }"
        >
          <form @submit.prevent="passes(updateProfile)">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <ValidationProvider
                    name="Name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="label">Name</label>
                    <div class="control has-icons-left">
                      <input
                        v-model="user.name"
                        minlength="5"
                        class="input"
                        :class="{ 'is-danger': errors.length }"
                        type="text"
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                      </span>
                    </div>
                    <p class="help is-danger" v-show="errors.length">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <ValidationProvider
                    name="Email"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="label">Email</label>
                    <div class="control has-icons-left">
                      <input
                        v-model="user.email"
                        class="input"
                        :class="{ 'is-danger': errors.length }"
                        type="text"
                        readonly="readonly"
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-envelope"></i>
                      </span>
                    </div>
                    <p class="help is-danger" v-show="errors.length">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <ValidationProvider
                    name="Phone number"
                    rules
                    v-slot="{ errors }"
                  >
                    <label class="label">Phone Number</label>
                    <div class="control has-icons-left">
                      <input
                        v-model="user.phone"
                        class="input"
                        :class="{ 'is-danger': errors.length }"
                        type="tel"
                        placeholder="555-555-5555"
                        v-mask="'###-###-####'"
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-phone"></i>
                      </span>
                    </div>
                    <p class="help is-danger" v-show="errors.length">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-one-quarter">
                <div class="field">
                  <input
                    :disabled="pristine || invalid || loading"
                    type="submit"
                    value="Update Profile"
                    class="button is-primary"
                  />
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <!-- Password form -->
      <div class="column is-half">
        <div class="is-divider is-hidden-desktop"></div>
        <div class="mt-2 pt-6 is-hidden-touch"></div>
        <ValidationObserver
          ref="observer"
          v-slot="{ pristine, invalid, passes }"
        >
          <form @submit.prevent="passes(updatePassword)">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <ValidationProvider
                    name="Password"
                    rules="required"
                    vid="password"
                    v-slot="{ errors }"
                  >
                    <label class="label">New Password</label>
                    <div class="control has-icons-left">
                      <input
                        class="input"
                        :class="{ 'is-danger': errors.length }"
                        type="password"
                        placeholder="Password"
                        v-model="newPassword.password"
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-lock"></i>
                      </span>
                    </div>
                    <p class="help is-danger" v-show="errors.length">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <ValidationProvider
                    name="Password confirmation"
                    rules="required|confirmed:password"
                    v-slot="{ errors }"
                  >
                    <label class="label">Confirm New Password</label>
                    <div class="control has-icons-left">
                      <input
                        class="input"
                        :class="{ 'is-danger': errors.length }"
                        type="password"
                        placeholder="Confirm Password"
                        v-model="newPassword.confirmPassword"
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-lock"></i>
                      </span>
                    </div>
                    <p class="help is-danger" v-show="errors.length">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-one-quarter">
                <div class="field">
                  <input
                    :disabled="pristine || invalid || loading"
                    type="submit"
                    value="Change Password"
                    class="button is-primary"
                  />
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
export default {
  name: 'ProfileForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: [
    'userData'
  ],
  data() {
    return {
      currentYear: this.$moment().year(),
      loading: false,
      disable: false,
      user: this.userData || {},
      newPassword: {
        password: '',
        confirmPassword: ''
      }
    };
  },
  watch: {
    userData: function() {
      this.user = this.userData;
    }
  },
  methods: {
    updateProfile() {
      this.success = false;
      this.generalError = '';

      const data = {
        name: this.user.name,
        phone: this.user.phone,
        email: this.user.email
      };

      this.loading = true;

      this.$axios
        .patch(this.$API.updateProfile(this.user._id), data)
        .then(response => {
          this.$store.commit('auth/setUser', response.data);
          this.$notify({
            group: 'alert',
            title: 'Success!',
            text: 'Successfully updated your profile information.',
            type: 'success'
          });
        })
        .catch(e => {
          this.$notify({
            group: 'alert',
            title: 'FAILED!',
            text:
              (e?.response?.data?.details[0]?.message) ||
              'Something went wrong while updating your profile information.',
            type: 'error'
          });
          console.error(e.response.data.message || e.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateProfilePicture() {
      this.disable = true;
      const file = this.$refs.file.files[0];
      const MAX_SIZE = 2097152; // 2 MB
      if (!file) {
        return (this.disable = false);
      }
      const tooLarge = file.size > MAX_SIZE;
      const allowedTypes = [
        'image/jpg',
        'image/jpeg',
        'image/png',
        'image/gif'
      ];
      if (!allowedTypes.includes(file.type)) {
        this.$notify({
          group: 'alert',
          title: 'FAILED!',
          text: 'Unsupported file type. Try uploading JPG, PNG, GIF or JPEG.',
          type: 'error'
        });
        this.disable = false;
        return;
      }
      if (tooLarge) {
        this.$notify({
          group: 'alert',
          title: 'FAILED!',
          text: 'File too large. Please keep your avatar under 2 MB.',
          type: 'error'
        });
        this.disable = false;
        return;
      }
      const formData = new FormData();
      formData.append('avatar', file);
      const options = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      this.$axios
        .post(this.$API.updateAvatar(this.user._id), formData, options)
        .then(response => {
          this.disable = false;
          // Add a timestamp to the avatar URL to update the picture in the view.
          response.data.avatar += `?_${Date.now()}`;
          this.user = response.data;
          this.$store.commit('auth/setUser', response.data);
        })
        .catch(e => {
          this.disable = false;
          this.$notify({
            group: 'alert',
            title: 'FAILED!',
            text: 'Unable to update avatar. Please check and try again.',
            type: 'error'
          });
          console.info('Error: ', e);
        });
    },
    updatePassword() {
      this.loading = true;
      this.$axios
        .put(this.$API.updatePassword(this.user._id), this.newPassword)
        .then(() => {
          this.newPassword.password = '';
          this.newPassword.confirmPassword = '';
          this.$notify({
            group: 'alert',
            title: 'Success!',
            text: 'Successfully updated your password.',
            type: 'success'
          });
        })
        .catch(() => {
          this.$notify({
            group: 'alert',
            title: 'FAILED!',
            text: 'Something went wrong while updating your password.',
            type: 'error'
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
